<div class="chat-session-view">
  <chat-state [state]="(session.state$ | async) || 'connected'"></chat-state>
  <chat-message-list
    class="chat-session-view__messages"
    [messages]="(session.messages$ | async) || []"
    [template]="template"
    [activity]="session.activity$ | async"
    [hasMoreBefore]="((session.hasMore$ | async)?.before) || false"
    [hasMoreAfter]="((session.hasMore$ | async)?.after) || false"
    [isLoadingBefore]="((session.isLoadingMore$ | async)?.before) || false"
    [isLoadingAfter]="((session.isLoadingMore$ | async)?.after) || false"
    [firstUnreadId]="(session.firstUnreadId$ | async) || null"
    [restoreScrollTop]="restoreScrollTop"
    (loadMoreBefore)="session.loadMore('before')"
    (loadMoreAfter)="session.loadMore('after')"
    (messageRead)="session.markReadUpTo($event)"
    (scrollPositionChange)="scrollPositionChange.emit($event)"
  ></chat-message-list>
</div>
<div class="footer">
    <chat-input
    [allowFiles]="allowFiles"
    [allowVoice]="allowVoice && !(session.voiceInputLocked$ | async)"
    [showCancelButton]="!!(session.activity$ | async)"
    (messageSent)="onMessageSent($event)"
    (cancelRequested)="session.cancel()"
    (typingChanged)="onTypingChanged($event)"
  ></chat-input>
</div>
